const graphGridSx = {
    flexGrow: 1,
    height: "55vh", // Use full height of the container
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "2vh",
}

const graphGridSxFullWidth = {
    flexGrow: 1,
    width: "100%", // Use full width of the container
    height: "100%", // Use full height of the container
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
}
const graphPaperSxFullWidth = {
    width: "100%", // Take the full width
    height: "100%", // Fill the entire height
    padding: 10,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
}

const graphPaperSx = {
    width: "100%", // Take the full width
    height: "100%", // Fill the entire height
    padding: 10,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
}

export function getGraphStyles(options = {}) {
    if (options.fullWidth) {
        return { size: 12, graphGridSx: graphGridSxFullWidth, graphPaperSx: graphPaperSxFullWidth }
    } else {
        return { size: 6, graphGridSx, graphPaperSx }
    }
}
